import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useIntl } from 'react-intl';
import { DialogComponent } from 'common/components';
import NewLead from 'modules/crm/containers/NewLead/NewLead';
import { IProfileInfoImt } from 'common/components/PersonProfile/interfaces';
import { createLeadProfileSuccessAction } from 'modules/crm/state/leads/actions';
import messages from 'common/messages/messages';
import modalTitles from 'common/messages/modalTitles';
import IgnoreBreadcrumbContext from 'common/contexts/IgnoreBreadcrumbContext';

interface IProps {
  profile: IProfileInfoImt;
  open?: boolean;
  onClose?: () => void;
}

const useStyles = makeStyles(() => ({
  addMembershipModal: {
    '&>.MuiDialog-container>.MuiDialog-paper': {
      height: '100%',
      '&>.MuiBox-root': {
        padding: 0,
      },
    },
  },
}));

export default function MembershipModal({
  open = false,
  onClose = () => {},
  profile,
}: IProps): JSX.Element {
  const dispatch = useDispatch();
  const classes = useStyles();
  const intl = useIntl();

  useEffect(() => {
    if (profile) {
      // added a lead to the state for used in step containers
      dispatch(createLeadProfileSuccessAction(profile.toJS() as any)); // TODO - PRM-3575 need types
    }
  }, [dispatch, profile]);

  return (
    <DialogComponent
      title={intl.formatMessage(
        profile?.get('membership') ? modalTitles.changePackagePlan : modalTitles.addMembership,
      )}
      submitBtnTitle={intl.formatMessage(messages.saveBtn)}
      size="md"
      className={classes.addMembershipModal}
      isOpen={open}
      onClose={onClose}
      hasShadowsOnScroll={false}
      hasCustomFooter
    >
      <IgnoreBreadcrumbContext.Provider value>
        <NewLead
          mainTitle={null}
          onCloseModal={onClose}
          profile={profile}
          hasChangePackagePlanMode
        />
      </IgnoreBreadcrumbContext.Provider>
    </DialogComponent>
  );
}
